import React, { useEffect, useState } from "react";
import { config } from "../../config";
import "../Shopkeeper/css/demo.css";
import "../Shopkeeper/css/ready.css";
import { Link, useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { BsQuestionOctagon } from "react-icons/bs";

export default function Profile() {
  const [promotions, setPromotions] = useState([]);
  const [error, setError] = useState(null);

  const fetchShopPromotions = async () => {
    const access_token = localStorage.getItem("accessToken");
    const locationId = localStorage.getItem("locationId");
    const userId = localStorage.getItem("userId");

    const url = `${config.api_base}api/v2/bcf11870-f401-427e-b940-1758c5a79540/shop/${userId}/promotion?page=0&offset=100&type=ALL`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch promotions");
      }

      const data = await response.json();
      console.log(url);

      console.log("Promotions:", data);
      setPromotions(data);
    } catch (err) {
      console.error("Error fetching promotions:", err);
      setError(err.message);
    }
  };



  useEffect(() => {
    fetchShopPromotions();
  }, []);


  const navigate = useNavigate();

  const handleLogout = (e) => {
    // e.preventDefault();

    // const confirmLogout = window.confirm("Are you sure you want to logout?");
    // if (confirmLogout) {
      localStorage.clear();
      localStorage.removeItem("accessToken");
      localStorage.removeItem("userId"); // Clear localStorage
      navigate("/"); // Navigate to home route
    // }
  };


   const [showModal, setShowModal] = useState(false);
  
    const handleShow = () => setShowModal(true);
    const handleClose = () => setShowModal(false);
  
    const confirmLogout = () => {
      handleLogout();
      handleClose();
    };
  

  return (
    <>
      {promotions && (
        <div className="wrapper">
       <div className="main-header">
            <div className="logo-header text-center">
              <a href="https://adoop.in/" target="_blank">
                <img
                  src="assets/img/logo/adoop-png.png"
                  style={{ width: "100px" }}
                  alt="logo"
                />
              </a>
              <button
                className="navbar-toggler sidenav-toggler ml-auto"
                type="button"
                data-toggle="collapse"
                data-target="collapse"
                aria-controls="sidebar"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <button className="topbar-toggler more">
                <i className="la la-ellipsis-v"></i>
              </button>
            </div>
            <nav className="navbar navbar-header navbar-expand-lg">
              <div className="container-fluid">
                <form
                  className="navbar-left navbar-form nav-search mr-md-3"
                  action=""
                >
                  {/* <div className="input-group">
                    <input
                      type="text"
                      placeholder="Search ..."
                      className="form-control"
                    />
                    <div className="input-group-append">
                      <span className="input-group-text">
                        <i className="fas fa-search"></i>
                      </span>
                    </div>
                  </div> */}
                </form>
                <ul className="navbar-nav topbar-nav ml-md-auto align-items-center">
                  <li className="nav-item dropdown">
                    <a
                      className="profile-pic"
                      href="#"
                      aria-expanded="false"
                      style={{ textDecoration: "none" }}
                    >
                      <img
                        src={`https://d3p6cw3ny59ckg.cloudfront.net/store/${promotions.shop?.logo}`}
                        alt="user-img"
                        width="36"
                        className="img-circle"
                      />
                      <span>
                        Hello, {promotions?.shop?.name || "Shopkeeper"}
                      </span>{" "}
                    </a>
                    <ul className="dropdown-menu dropdown-user">
                      <li>
                        <div className="user-box">
                          <div className="u-img">
                            <img src="assets/img/profile.jpg" alt="user" />
                          </div>
                          <div className="u-text">
                            <h4> {promotions?.shop?.name || "Shopkeeper"}</h4>
                            <p className="text-muted">kktannu60@.com</p>
                            <a
                              href="profile.html"
                              className="btn btn-rounded btn-danger btn-sm"
                            >
                              View Profile
                            </a>
                          </div>
                        </div>
                      </li>
                      <div className="dropdown-divider"></div>
                      <a className="dropdown-item" href="#">
                        <i className="ti-user"></i> My Profile
                      </a>
                      <a className="dropdown-item" href="#">
                        {" "}
                        My Balance
                      </a>
                      <a className="dropdown-item" href="#">
                        <i className="ti-email"></i> Inbox
                      </a>
                      <div className="dropdown-divider"></div>

                      <a className="dropdown-item" href="#">
                        <i className="fa fa-power-off"></i> Logout
                      </a>
                    </ul>
                    {/* <!-- /.dropdown-user --> */}
                  </li>
                </ul>
              </div>
            </nav>
          </div>
          <div className="sidebar">
            <div className="scrollbar-inner sidebar-wrapper">
              <ul className="nav">
                <li className="nav-item">
                  <Link to="/shophome" style={{textDecoration:"none"}}>
                    <i class="fa-solid fa-house"></i>
                    <p>Home</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/addpromotions" style={{textDecoration:"none"}}>
                  <i class="bi bi-megaphone-fill"></i> 
                    <p>Promo</p>
                  </Link>
                </li>
                <li className="nav-item active">
                  <Link to="/shopProfile" style={{textDecoration:"none"}}>
                    <i class="bi bi-person-fill"></i>
                    <p>Profile</p>
                  </Link>
                </li>
                 <li className="nav-item">
                                <Link to="/shopPricing" style={{ textDecoration: "none" }}>
                                  <i class="bi bi-cash"></i>
                                  <p>My Subscription</p>
                                </Link>
                              </li>
                <li className="nav-item">
       <Link
                  to="#"
                  onClick={handleShow}
                  style={{ textDecoration: "none" }}
                >
                  <i className="fa-solid fa-right-from-bracket"></i>
                  <p>Logout</p>
                </Link>

                {/* React Bootstrap Modal */}
                <Modal
                  show={showModal}
                  onHide={handleClose}
                  size="sm"
                  // centered
                  dialogClassName="custom-logout-modal"
                >
                  <Modal.Header closeButton className="modal-header-warning">
                    <Modal.Title style={{ fontSize: "18px", color: "#fff" }}>
                      Sign Out
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body className="d-flex align-items-center gap-2">
                    <BsQuestionOctagon size={20} className="text-dark" />
                    <span>Do you really want to sign out?</span>
                  </Modal.Body>
                  <Modal.Footer className="justify-content-end">
                    <Button
                      variant="outline-secondary"
                      className="btn-no"
                      onClick={handleClose}
                    >
                      No
                    </Button>
                    <Button
                      variant="light" // prevents default "primary" background
                      className="btn-yes ms-2"
                      style={{
                        backgroundColor: "#ffc600",
                        border: "none",
                        color: "black",
                      }}
                      onClick={confirmLogout}
                    >
                      Yes
                    </Button>
                  </Modal.Footer>
                </Modal>
    </li>
              </ul>
            </div>
          </div>
          {/* <div className="main-panel">
      <div className="content">
        <div className="container-fluid">
          <h4 className="page-title">Profile</h4>
          <div className="card">
  <div className="card-body">
  
    <p><strong>Name:</strong> {promotions.shop?.name}</p>
    <p><strong>Phone:</strong> {promotions.shop?.user_info?.mobile}</p>
    <p><strong>Address:</strong> {promotions.shop?.address}</p>
    <p><strong>City:</strong> {promotions.shop?.cityName}</p>
    <p><strong>State:</strong> {promotions.shop?.stateName}</p>
  </div>

  <div className="card-image">
    
    <img 
  src={`https://d3p6cw3ny59ckg.cloudfront.net/store/${promotions.shop?.logo}`} 
  alt="Shop Image" 
  style={{ objectFit: 'cover' }} 
/>
 </div>
</div>

        </div>
      </div>
    </div> */}

<div className="main-panel">
            <div className="content">
                <div className="container bg-white p-3 rounded mb-4 ">
                    <h4 className="page-title">View Profile</h4>
                   

                    <div className="row">
                       <div className="col-md-4 border-yellow">
  <div className="d-flex flex-column align-items-center text-center p-3 py-5">
    <img
      className="rounded-circle mt-5 mb-3"
      width="150px"
      height={150}
      src={`https://d3p6cw3ny59ckg.cloudfront.net/store/${promotions.shop?.logo}`}
    />
    
    <span className="font-weight-bold">{promotions.shop?.name}</span>

    {/* 👇 Add margin here for spacing */}
    <span className="text-black-50 mt-2 d-flex align-items-center gap-1">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#ffc600" className="bi bi-geo-alt-fill" viewBox="0 0 16 16">
        <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6"/>
      </svg>
      {promotions.shop?.cityName}, {promotions.shop?.stateName}
    </span>
  </div>
</div>

                        <div className="col-md-8 border-right">
                            <div className="p-3 py-5">
                                <div className="row ">
                                    <div className="col-md-12 mb-3"><label className="labels">Shop Name</label>
                                        <input type="text" className="form-control" placeholder="Star Electronics" value={promotions.shop?.name}
                                            disabled />
                                    </div>
                                    <div className="col-md-12 mb-3"><label className="labels">Mobile Number</label><input
                                            type="text" className="form-control" placeholder="+91 9876543210" value={promotions.shop?.user_info?.mobile} disabled />
                                    </div>
                                    <div className="col-md-12 mb-3"><label className="labels">Shop Address</label><input
                                            type="text" className="form-control" placeholder="123 MG Road" value={promotions.shop?.address} disabled /></div>
                                   
                                    <div className="col-md-12 mb-3"><label className="labels">City</label><input type="text"
                                            className="form-control" placeholder="Ludhiana" value={promotions.shop?.cityName} disabled /></div>
                                    <div className="col-md-12 mb-3"><label className="labels">State</label><input type="text"
                                            className="form-control" placeholder="Punjab" value={promotions.shop?.stateName} disabled /></div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
           
        </div>
        </div>
      )}
    </>
  );
}
